// Российская карта. Оплата через 3D-Secure.
export const CARD_NUMBER_MIR = '2200000000000004';

// Узбекская карта без CVV.
export const CARD_NUMBER_HUMO = '9860000000000000';

// Американская карта с большим набором доп. полей.
export const CARD_NUMBER_VIZA = '4242424242424242';

// Имя мерчанта.
export const MERCHANT_NAME = 'MyGame';

// Неуспешная оплата.
export const PUBLIC_TOKEN_LOSER =
  'f63de060137ad5d14d57484743e7e400244dd590eea60a87a58f2202dff1c277';

// Успешная оплата из России.
export const PUBLIC_TOKEN_LUCKY_FROM_RUS =
  'ad98b20b772dbe7a5b1d09d1ce72bda8945c619a8bdc933d47f64f047bd69b33';

// Успешная оплата из USA.
export const PUBLIC_TOKEN_LUCKY_FROM_USA =
  '182f57349822e38b7044bf23728e4c552ce672ea8c00025b1b17818944e0015b';
